import { Button, notification } from '@pankod/refine-antd';
import { IFormValues, MakePayment } from 'components';
import { EPaymentType } from 'enums';
import { IPaymentLog } from 'interfaces';
import { useState } from 'react';
import { createPaymentLog, getPaymentLogs } from 'services/payment';

interface IPaymentLogState extends IPaymentLog {
  currentPendingAmount: number;
}

type AddPaymentLogProps = {
  resource: 'sales' | 'purchase';
  resourceId: string;
  paymentBy: 'client' | 'supplier';
  paymentById: string;
  totalPendingAmount: number;
  totalPayableAmount: number;
  setPaymentLogs: React.Dispatch<React.SetStateAction<IPaymentLogState[]>>;
};

export const AddPaymentLog: React.FC<AddPaymentLogProps> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const onPaymentSubmit = async (data: IFormValues) => {
    setIsPaymentLoading(true);

    const {
      paymentType,
      paymentMethod,
      paymentDetails,
      currentPaidAmount,
      attachments,
      companyBank,
      phoneNumber,
      transactionId,
      cardNumber,
      approvalCode,
    } = data;

    try {
      const data: any = {
        paymentType,
        paymentMethod,
        paymentDetails,
        currentPaidAmount,
        companyBank,
        paymentDate: new Date(),
        attachments,
        [`${props.resource}Copy`]: props.resourceId,
        paymentMeta: null,
      };

      // Conditionally build and assign paymentMeta
      if (props.resource === 'sales' && paymentType === EPaymentType.Card) {
        data.paymentMeta = {
          cardNo: cardNumber,
          approvalCode: approvalCode,
        };
      }

      if (
        props.resource === 'sales' &&
        (paymentType === EPaymentType.Bkash || paymentType === EPaymentType.Nagad)
      ) {
        data.paymentMeta = {
          phoneNo: phoneNumber,
          transactionId: transactionId,
        };
      }

      await createPaymentLog(props.resource === 'sales' ? 'sale' : props.resource, data);
      let currentPendingAmount = props.totalPayableAmount;
      const paymentLogs = await getPaymentLogs(props.resource, props.resourceId);
      const extendedPaymentLogs = paymentLogs.map((paymentLog) => {
        currentPendingAmount -= paymentLog.currentPaidAmount;
        return { ...paymentLog, currentPendingAmount };
      });
      props.setPaymentLogs(extendedPaymentLogs);

      notification.success({
        message: 'Success',
        description: 'Successfully added a payment.',
      });
    } catch (err: any) {
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }

    closeDrawer();
    setIsPaymentLoading(false);
  };

  return (
    <>
      {!visible && <Button onClick={showDrawer}>Add Payment</Button>}
      <MakePayment
        paymentBy={props.paymentBy}
        paymentById={props.paymentById}
        totalPayableAmount={props.totalPendingAmount}
        loading={isPaymentLoading}
        visible={visible}
        closeDrawer={closeDrawer}
        onPaymentSubmit={onPaymentSubmit}
      />
    </>
  );
};
